import { FallbackError } from "@core/domain/errors/fallback.error";
import { SpatialLevelDatasource } from "@station/data/datasources/spatial-level.datasource.ts";
import { SpatialLevels } from "@station/domain/models/spatial-level.model.ts";
import type { Station } from "@station/domain/models/station.model";
import type { SpatialLevelRepository } from "@station/domain/repositories/spatial-level.repository.ts";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";
import { BehaviorSubject } from "rxjs";

@injectable()
export class SpatialLevelImplRepository implements SpatialLevelRepository {
    constructor(
        @inject(SpatialLevelDatasource)
        private readonly spatialLevelDatasource: SpatialLevelDatasource,
    ) {}

    private _spatialLevels: BehaviorSubject<SpatialLevels> =
        new BehaviorSubject<SpatialLevels>(SpatialLevels.empty());

    get spatialLevels(): SpatialLevels {
        return this._spatialLevels.value;
    }

    set spatialLevels(spatialLevels: SpatialLevels) {
        this._spatialLevels.next(spatialLevels);
    }

    getAll(): ResultAsync<SpatialLevels, FallbackError> {
        return this.spatialLevelDatasource.fetchAll();
    }

    spatialLevelsGetLocal(): SpatialLevels {
        return this._spatialLevels.value;
    }

    spatialLevelsSetLocal(spatialLevels: SpatialLevels): void {
        this._spatialLevels.next(spatialLevels);
    }

    emptySpatialLevels(): void {
        this._spatialLevels.next(SpatialLevels.empty());
    }

    refreshStation(station: Readonly<Station>): void {
        this._spatialLevels.next(
            this._spatialLevels.value.withStationRefreshed(station),
        );
    }
}
